import { SettingsRoutes } from 'pages/settings/route/type'
import { MembersRoutes } from 'pages/settings/pages/members/route/type'

const root = `${SettingsRoutes.root}/${MembersRoutes.root}`
const add = `${root}/${MembersRoutes.add}`
const pending = `${SettingsRoutes.root}/${MembersRoutes.root}/${MembersRoutes.pending}`
const permissionsUpdate = `${SettingsRoutes.root}/${MembersRoutes.root}/${MembersRoutes.requests}/${MembersRoutes.permissionsUpdate}`

export const MembersPath = {
  root: root,
  add: add,
  pending: pending,
  permissionsUpdate: permissionsUpdate,
}
